import React, { useState } from 'react';
import Button from './Button';
import Select from './Select';
import Input from './Input';
import { TICKET_STATUSES } from '../../constants/statuses';

const AdvancedFilters = ({ onApply, onReset, engineers = [], sites = [] }) => {
  const [filters, setFilters] = useState({
    status: '',
    priority: '',
    assignee: '',
    site: '',
    startDate: '',
    endDate: ''
  });

  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleApply = () => {
    onApply(filters);
    setIsOpen(false);
  };

  const handleReset = () => {
    const resetFilters = {
      status: '',
      priority: '',
      assignee: '',
      site: '',
      startDate: '',
      endDate: ''
    };
    setFilters(resetFilters);
    onReset();
    setIsOpen(false);
  };

  const activeFiltersCount = Object.values(filters).filter(v => v !== '').length;

  const containerStyle = {
    position: 'relative'
  };

  const buttonStyle = {
    position: 'relative'
  };

  const badgeStyle = {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    background: 'var(--primary)',
    color: 'white',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    fontSize: '11px',
    fontWeight: '700',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const dropdownStyle = {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: '8px',
    width: '400px',
    maxWidth: '90vw',
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
    zIndex: 1000
  };

  const titleStyle = {
    fontSize: '16px',
    fontWeight: '700',
    color: 'var(--text-primary)',
    marginBottom: '16px'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px',
    marginBottom: '16px'
  };

  const actionsStyle = {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
    marginTop: '16px'
  };

  const statusOptions = [
    { value: TICKET_STATUSES.PENDING_ASSIGNMENT, label: 'Pending Assignment' },
    { value: TICKET_STATUSES.ASSIGNED, label: 'Assigned' },
    { value: TICKET_STATUSES.WORK_IN_PROGRESS, label: 'Work In Progress' },
    { value: TICKET_STATUSES.PENDING, label: 'Pending' },
    { value: TICKET_STATUSES.CLOSED, label: 'Completed' }
  ];

  const priorityOptions = [
    { value: 'CRITICAL', label: 'Critical' },
    { value: 'HIGH', label: 'High' },
    { value: 'NORMAL', label: 'Normal' },
    { value: 'LOW', label: 'Low' }
  ];

  const engineerOptions = engineers.map(eng => ({
    value: eng.id.toString(),
    label: eng.name
  }));

  const siteOptions = sites.map(site => ({
    value: site.value,
    label: site.label
  }));

  return (
    <div style={containerStyle}>
      <div style={buttonStyle}>
        <Button 
          variant="secondary" 
          onClick={() => setIsOpen(!isOpen)}
        >
          Advanced Filters
        </Button>
        {activeFiltersCount > 0 && (
          <div style={badgeStyle}>{activeFiltersCount}</div>
        )}
      </div>

      {isOpen && (
        <>
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999
            }}
            onClick={() => setIsOpen(false)}
          />
          <div style={dropdownStyle}>
            <div style={titleStyle}>Filter Tickets</div>

            <div style={gridStyle}>
              <Select
                label="Status"
                name="status"
                value={filters.status}
                onChange={handleChange}
                options={statusOptions}
                placeholder="All Statuses"
              />

              <Select
                label="Priority"
                name="priority"
                value={filters.priority}
                onChange={handleChange}
                options={priorityOptions}
                placeholder="All Priorities"
              />
            </div>

            <div style={gridStyle}>
              <Select
                label="Assigned To"
                name="assignee"
                value={filters.assignee}
                onChange={handleChange}
                options={engineerOptions}
                placeholder="All Engineers"
              />

              <Select
                label="Site"
                name="site"
                value={filters.site}
                onChange={handleChange}
                options={siteOptions}
                placeholder="All Sites"
              />
            </div>

            <div style={gridStyle}>
              <Input
                label="Start Date"
                name="startDate"
                type="date"
                value={filters.startDate}
                onChange={handleChange}
              />

              <Input
                label="End Date"
                name="endDate"
                type="date"
                value={filters.endDate}
                onChange={handleChange}
              />
            </div>

            <div style={actionsStyle}>
              <Button variant="secondary" onClick={handleReset}>
                Clear All
              </Button>
              <Button variant="primary" onClick={handleApply}>
                Apply Filters
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdvancedFilters;